import React from 'react';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
import { TrustBadges } from './TrustBadges';
export function Hero() {
  return <section className="pt-4 pb-4 px-4 sm:px-6 bg-white text-center" data-id="element-71" data-mp="ei1vfm5pk2xy">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-blush text-brand-plum font-bold text-[10px] sm:text-[11px] mb-2 tracking-wide uppercase" data-id="element-72" data-mp="9lbkfd8rfxje">
        ✦ Il Sistema Completo 6-in-1 per Allenatori
      </div>
      <h1 className="font-display text-[26px] leading-[0.95] sm:text-5xl tracking-wide text-brand-plum mb-2 uppercase" data-id="element-73" data-mp="xannrwhepbds">
        Il Sistema Completo di Pianificazione per Allenatori di Ginnastica Ritmica
      </h1>
      <p className="text-[13px] sm:text-base text-brand-slate font-semibold leading-snug mb-3 max-w-2xl mx-auto" data-id="element-74" data-mp="ncq1vfn0rqoc">
        Risparmia ore ogni settimana preparando allenamenti, pianificazioni, esercizi, progressioni e documentazione
        tecnica, senza dover creare tutto da zero ogni volta.
      </p>
      <div className="mb-3" data-id="element-75" data-mp="3j896tarbk7oh">
        <ProductImage className="max-w-[280px] sm:max-w-sm" data-id="element-76" data-mp="3j925dog4jqvj" />
      </div>
      <div className="max-w-md mx-auto mb-2" data-id="element-77" data-mp="3o7vlzpqpjxzx">
        <CTAButton data-id="element-78" data-mp="3o5j3nbh1flmc">🚀 SÌ! VOGLIO RHYTHMIC GYM PRO™ ORA</CTAButton>
      </div>
      <TrustBadges data-id="element-79" data-mp="399tex5kgwudx" />
    </section>;
}